import styled from "styled-components";
import Vector from "../../../assets/images/EmptyCheckout.png";
import Drop from "../../../assets/images/Drop.png";
import Skeleton from "../skeletons/Skeleton";

const Styles = styled.div`
    .frame-295922869,
    .frame-295922869 * {
        box-sizing: border-box;
    }
    .frame-295922869 {
        padding: 32px 0px 0px 0px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-313691 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .vector {
        flex-shrink: 0;
        width: 59.76px;
        height: 60px;
        position: relative;
        overflow: visible;
    }
    .frame-295922870 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .no-stores-to-show-read-message-on-the-b-otag-or-close-this-panel {
        text-align: center;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .no-stores-to-show-read-message-on-the-b-otag-or-close-this-panel-span {
        color: var(--text-text-primary, #ffffff);
        font-family: var(--heading-2-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--heading-2-font-size, 18px);
        line-height: var(--heading-2-line-height, 28px);
        font-weight: var(--heading-2-font-weight, 600);
    }
    .no-stores-to-show-read-message-on-the-b-otag-or-close-this-panel-span2 {
        color: var(--text-text-secondary, #8c8c8c);
        font-family: var(--body-text-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--body-text-font-size, 14px);
        line-height: var(--body-text-line-height, 24px);
        letter-spacing: var(--body-text-letter-spacing, -0.015em);
        font-weight: var(--body-text-font-weight, 400);
    }
    .vector2 {
        flex-shrink: 0;
        width: 15px;
        height: 18.75px;
        position: absolute;
        left: 153px;
        top: 30px;
        overflow: visible;
    }
`;
const EmptyStoresPanel = ({ availableStoresLoader }) => {
    return (
        <Styles className="w-100">
            {availableStoresLoader ? (
                <Skeleton width={"100%"} height={"100%"} type={"product"} />
            ) : (
                <div className="frame-295922869">
                    <div className="frame-313691">
                        <img className="vector" src={Vector} alt="" />
                        <div className="frame-295922870">
                            <div className="no-stores-to-show-read-message-on-the-b-otag-or-close-this-panel">
                                <span>
                                    <span className="no-stores-to-show-read-message-on-the-b-otag-or-close-this-panel-span">
                                        No stores to show.
                                        <br />
                                    </span>
                                    <span className="no-stores-to-show-read-message-on-the-b-otag-or-close-this-panel-span2">
                                        Read message on the BOtag or close this panel.
                                    </span>
                                </span>
                            </div>
                        </div>
                        <img className="vector2" src={Drop} alt="" />
                    </div>
                </div>
            )}
        </Styles>
    );
};

export default EmptyStoresPanel;
